import * as React from 'react';
import { State } from 'moduleBase/types/State';
import { bindActionCreators } from 'redux';
import { menuMainLoad } from 'moduleBase/modules/menu/actions/main-load';
import { REDUCER_MENU_NAME } from 'moduleBase/modules/menu/constants';
import { MenuPanelTabs } from 'moduleBase/modules/menu/components/mobile/MenuPanelTabs';
import { MenuPanelBottom } from 'moduleBase/modules/menu/components/mobile/MenuPanelBottom';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { StateType } from 'moduleBaseMenu/types/StateType';
import { FC } from 'react';

type PropsType = StateType & {
  hide: () => void,
};

const MobileNav: FC<PropsType> = ({
  hide,
  menu,
}) => (
  <>
    <MenuPanelTabs menu={menu} hide={hide} />
    <MenuPanelBottom menu={menu} hide={hide} />
  </>
);

export default connect(MobileNav, {
  mapStateToProps: (state: State) => state[REDUCER_MENU_NAME],
  mapDispatchToProps: (dispatch) => (bindActionCreators({
    load: menuMainLoad,
  }, dispatch)),
});
